document.addEventListener('click', function (e) {
    const menuToggle = document.querySelector('.main-menu-toggle')

    if (e.target.classList.contains('main-menu-toggle-btn')) {
        document.body.classList.toggle('main-menu-open')
    }

    if (e.target !== menuToggle && !menuToggle.contains(e.target)) {
        document.body.classList.remove('main-menu-open')
    }

    // Shop menu
    if (e.target.classList.contains('shop-item-button')) {
        const menuShopParent = e.target.closest('.menu-item-has-children')

        if (menuShopParent.classList.contains('active')) {
            menuShopParent.classList.remove('active', 'show')
        } else {
            menuShopParent.classList.add('active')

            setTimeout(() => {
                menuShopParent.classList.add('show')
            }, 100)
        }
    }

    const shopMenuDropdown = document.querySelector('#shop-menu .menu-item-has-children.active')
    if (shopMenuDropdown && e.target !== shopMenuDropdown && !shopMenuDropdown.contains(e.target)) {
        shopMenuDropdown.classList.remove('active', 'show')
    }

    // Main menu
    if (e.target.classList.contains('main-item-button')) {
        const menuParent = e.target.closest('.menu-item-has-children')

        if (menuParent.classList.contains('active')) {
            menuParent.classList.remove('active', 'show')
        } else {
            menuParent.classList.add('active')

            setTimeout(() => {
                menuParent.classList.add('show')
            }, 100)
        }
    }
})
